import './App.css';
import Weather from './Weather';

function App() {
  
  return (
   <div>
      <Weather defaultCity="Myanmar"/>
      

   </div>
   
  );
}

export default App;
